import { useCallback, useState } from 'react';
import { Icon } from '../../Icon.js';
import { VipFeatureModal } from '../VipFeatureModal.js';

export interface DaaluuAutoPlayButtonProps {
  autoPlay: boolean;
  isVip: boolean;
  mn: boolean;
  onToggle: (enabled: boolean) => void;
  onOpenProfile?: () => void;
}

type ButtonState = 'on' | 'off' | 'locked';
const TITLES_EN = {
  on: 'Auto-play is on · turn off',
  off: 'Turn on auto-play',
  locked: 'Auto-play · VIP only',
} as const satisfies Record<ButtonState, string>;
const TITLES_MN = {
  on: 'Автомат тоглолт асаалттай · унтраах',
  off: 'Автомат тоглолт асаах',
  locked: 'Автомат тоглолт · зөвхөн VIP',
} as const satisfies Record<ButtonState, string>;

function buttonState(autoPlay: boolean, isVip: boolean): ButtonState {
  if (autoPlay) return 'on';
  return isVip ? 'off' : 'locked';
}

/**
 * Auto-play is a VIP feature. Everyone sees the bot icon; a non-VIP press opens
 * the VIP prompt instead of switching it on. Switching off always works.
 */
export function DaaluuAutoPlayButton({ autoPlay, isVip, mn, onToggle, onOpenProfile }: DaaluuAutoPlayButtonProps) {
  const [showVip, setShowVip] = useState(false);
  const closeVip = useCallback(() => setShowVip(false), []);

  const label = mn ? 'Автомат тоглолт' : 'Auto-play';
  const title = (mn ? TITLES_MN : TITLES_EN)[buttonState(autoPlay, isVip)];

  const onClick = (): void => {
    if (autoPlay || isVip) onToggle(!autoPlay);
    else setShowVip(true);
  };

  return <>
    <button type="button" className={`icon-button daaluu-autoplay-toggle${autoPlay ? ' is-on' : ''}`} aria-pressed={autoPlay}
      aria-label={label} title={title} data-tooltip={title} onClick={onClick}>
      <Icon name="bot" size={15} />
    </button>
    {showVip && <VipFeatureModal isMn={mn} onClose={closeVip} onUnlock={() => onOpenProfile?.()}
      title={mn ? 'Автомат тоглолт зөвхөн VIP гишүүдэд' : 'Auto-play is for VIP members'}
      description={mn
        ? 'Түр холдох үед таны ээлжийг автоматаар тоглоно. Хүссэн үедээ унтрааж болно.'
        : 'The game plays your turns for you while you step away. Turn it off any time.'} />}
  </>;
}
